/**
 * @name MessageTemplatesController
 * @description Controller for message templates
 * @param {service} Shop Shop service
 * @param {service} Session Session service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function MessageTemplatesController(
  Shop,
  Session,
  MessageTemplates
) {
  let vm = this;

  vm.$onInit = function() {
    vm.saveMessageTemplates = saveMessageTemplates;
    vm.session = Session;
  };

  // Get the message templates from the entity passed through the resolve
  MessageTemplates.get(vm.messageTemplatesOwner.message_templates)
  .then(function(response) {
    vm.messageTemplates = response;
  });

  /**
   * @name saveMessageTemplates
   * @description Function to update message templates
   * @param {object} messageTemplates The message templates to update
   */
  function saveMessageTemplates(messageTemplates) {
    MessageTemplates.update(messageTemplates).then(function(response) {
      vm.messageTemplates = response;
    });
  }
}

angular
.module('inkfinder')
.controller('MessageTemplatesController', MessageTemplatesController);



// WEBPACK FOOTER //
// ./components/message-templates/message-templates.controller.js